module.exports = __webpack_public_path__ + "images/feature/insert-img-6149b864d2199e9e317c86825817c1b9.jpg";